document.addEventListener('DOMContentLoaded', function() {
  let isDesktop = window.innerWidth >= 769; // Detect initial view mode
  let isMobileMenuOpen = false;
  const mobileMenu = document.querySelector('.mobile-menu');
  const menuToggleButton = document.querySelector('.header__icon--menu');
  const detailsMenu = document.querySelector('details#Details-menu-drawer-container');

  // Function to prevent the desktop details menu from opening in mobile view
  function preventDesktopDetailsMenuOnMobile() {
    if (!isDesktop && detailsMenu) {
      detailsMenu.removeAttribute('open');  // Ensure the desktop menu is closed
      detailsMenu.addEventListener('toggle', function(event) {
        // Prevent the desktop details menu from opening in mobile view
        if (!isDesktop) {
          event.preventDefault();  // Block the toggle event on mobile view
          detailsMenu.removeAttribute('open');  // Close it forcibly if open
        }
      });
    }
  }

  // Mobile-specific setup
  function setupMobileView() {
    console.log('Setting up mobile view.');
    mobileMenu.classList.remove('menu-open');  // Ensure menu is hidden by default
    isMobileMenuOpen = false;

    // Ensure all accordion contents are hidden by default
    document.querySelectorAll('.accordion-content').forEach(content => {
      content.classList.remove('accordion-open');  // Close all accordion contents on load
    });

    if (menuToggleButton) {
      menuToggleButton.addEventListener('click', toggleMobileMenu);
    }

    // Handle accordion button clicks
    document.querySelectorAll('.toggle-button').forEach(toggleButton => {
      toggleButton.addEventListener('click', toggleAccordion);
    });

    preventDesktopDetailsMenuOnMobile();  // Ensure desktop details menu is disabled on mobile
  }

  // Mobile teardown
  function teardownMobileView() {
    console.log('Tearing down mobile view.');
    if (menuToggleButton) {
      menuToggleButton.removeEventListener('click', toggleMobileMenu);
    }

    document.querySelectorAll('.toggle-button').forEach(toggleButton => {
      toggleButton.removeEventListener('click', toggleAccordion);
    });

    // Stop preventing the desktop details menu toggle when switching to desktop
    if (detailsMenu) {
      detailsMenu.removeEventListener('toggle', preventDesktopDetailsMenuOnMobile);
    }
  }

  // Desktop-specific setup
  function setupDesktopView() {
    console.log('Setting up desktop view.');
    mobileMenu.classList.remove('menu-open');  // Ensure mobile menu is hidden in desktop view
    document.body.style.overflow = 'auto';  // Enable scrolling
  }

  // Toggle mobile menu when header icon is clicked
  function toggleMobileMenu(event) {
    console.log('Mobile menu toggle button clicked.');
    event.preventDefault();
    isMobileMenuOpen = !isMobileMenuOpen;

    if (isMobileMenuOpen) {
      mobileMenu.classList.add('menu-open');  // Add class to open the menu
      document.body.style.overflow = 'hidden'; // Prevent background scrolling
    } else {
      mobileMenu.classList.remove('menu-open');  // Remove class to close the menu
      document.body.style.overflow = 'auto'; // Allow background scrolling
    }

    console.log(`Mobile menu open state: ${isMobileMenuOpen}`);
  }

  // Toggle accordion for submenus in mobile view
  function toggleAccordion(event) {
    console.log(`Accordion toggle button clicked: ${event.currentTarget.outerHTML}`);
    event.preventDefault();
    event.stopPropagation();

    const toggleButton = event.currentTarget;
    const accordionContent = toggleButton.parentElement.nextElementSibling;
    const isVisible = accordionContent.classList.contains('accordion-open');

    // Close all accordion contents
    document.querySelectorAll('.accordion-content').forEach(content => {
      content.classList.remove('accordion-open');  // Close all
    });

    document.querySelectorAll('.toggle-button').forEach(btn => {
      btn.querySelector('.icon').textContent = '+';  // Reset icons for all toggle buttons
    });

    // Toggle current accordion content
    if (!isVisible) {
      toggleButton.querySelector('.icon').textContent = '-';  // Change icon to indicate it's open
      accordionContent.classList.add('accordion-open');  // Show the accordion content
    } else {
      toggleButton.querySelector('.icon').textContent = '+';  // Change icon back to default
      accordionContent.classList.remove('accordion-open');  // Hide the accordion content
    }

    console.log(`Accordion content visibility: ${accordionContent.classList.contains('accordion-open')}`);
  }

  // Check if the view mode has changed (desktop to mobile or vice versa)
  function checkViewMode() {
    const currentlyDesktop = window.innerWidth >= 769;
    if (currentlyDesktop !== isDesktop) {
      if (currentlyDesktop) {
        teardownMobileView();
        setupDesktopView();  // Only set up desktop if it's in desktop view
      } else {
        teardownMobileView(); // Corrected function name
        setupMobileView();  // Only set up mobile if it's in mobile view
      }
      isDesktop = currentlyDesktop;  // Update the view mode flag
    }
  }

  // Initial setup based on the current view (desktop or mobile)
  window.addEventListener('resize', checkViewMode);

  if (isDesktop) {
    setupDesktopView();
  } else {
    setupMobileView();
  }
});
